import React from 'react';
import { AppBar, Box, Toolbar, Typography } from '@mui/material';

// Import your custom images
import headerBackground from '../assets/header1.jpg';
import logoImage from '../assets/logo.svg';

const TEXT_COLOR = '#042C54';

const AppHeader: React.FC = () => {
  const [formattedDate, setFormattedDate] = React.useState('');
  const [formattedTime, setFormattedTime] = React.useState('');

  React.useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setFormattedDate(now.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }));
      setFormattedTime(now.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      }));
    };

    updateDateTime();
    const interval = setInterval(updateDateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: `url(${headerBackground})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: TEXT_COLOR,
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05)',
        height: 100
      }}
    >
      <Toolbar sx={{ height: '100%', minHeight: '100%', display: 'flex', justifyContent: 'space-between' }}>
        {/* Date and Time Display */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            pl: 4,
            pt: 1,
            height: 'auto',
            position: 'absolute',
            top: 0,
            left: 0,
            background: 'transparent'
          }}
        >
          <Typography 
            variant="h6" 
            component="div"
            sx={{ 
              fontFamily: "'Montserrat', sans-serif",
              fontWeight: 500,
              color: '#042C54',
              letterSpacing: 1.2,
              fontSize: '1.1rem'
            }}
          >
            {formattedDate}
          </Typography>
          <Typography 
            variant="body1" 
            component="div"
            sx={{ 
              fontFamily: "'Roboto Condensed', sans-serif",
              fontWeight: 600,
              color: '#031B34',
              letterSpacing: 1,
              fontSize: '0.7rem',
              mt: 0.5
            }}
          >
            {formattedTime}
          </Typography>
        </Box>

        {/* Logo Section */}
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'flex-end',
            position: 'absolute',
            top: 0,
            right: 0,
            px: 0,
            py: 0,
            borderRadius: 0,
            overflow: 'visible',
            background: 'transparent',
            boxShadow: 'none',
            width: '40%', 
            height: '100%',
            mr: 3,
          }}
        >
          <Box
            component="img"
            src={logoImage}
            alt="Finance OCR Logo"
            sx={{
              position: 'absolute',
              top: '50%',
              right: 0,
              transform: 'translateY(-50%)',
              height: '90%',
              width: 'auto',
              maxWidth: '100%',
              objectFit: 'contain',
              objectPosition: 'right center',
              opacity: 1,
              filter: 'drop-shadow(0 4px 6px rgba(0, 0, 0, 0.6)) brightness(1.05) contrast(1.1)',
              zIndex: 10,
              transition: 'all 0.3s ease',
              '&:hover': {
                filter: 'drop-shadow(0 5px 8px rgba(0, 0, 0, 0.7)) brightness(1.1) contrast(1.15)',
              }
            }}
          />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AppHeader; 